import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { PrintLetterhead } from './types';

/** Company, then branch. A field that is not set is left out: never a label with a blank value. */
export function Letterhead({ data }: { data: PrintLetterhead }): ReactNode {
  const { t } = useTranslation();
  const company: { key: string; label: string; value: string | null }[] = [
    { key: 'reg', label: t('print.regNo'), value: data.registrationNo },
    { key: 'tin', label: t('print.tin'), value: data.tin },
    { key: 'email', label: t('print.email'), value: data.email },
    { key: 'web', label: t('print.website'), value: data.website },
  ];
  return (
    <header className="print-letterhead">
      <div className="print-legal-name">{data.legalName}</div>
      {company.map((f) =>
        f.value === null || f.value.trim().length === 0 ? null : (
          <div key={f.key} className="print-small">
            {f.label} {f.value}
          </div>
        ),
      )}
      <div className="print-branch">{data.branchName}</div>
      {data.addressLines.map((line) => (
        <div key={line} className="print-small">
          {line}
        </div>
      ))}
      {data.phone === null ? null : <div className="print-small">{data.phone}</div>}
    </header>
  );
}
